// Update the environment variables in the .env file before running the application
export const BASE_URL = process.env.REACT_APP_BASE_URL || "https://api-v3.sattvamedtech.in/v3/dashboard";
export const S3_REPORT_BASE_URL = "https://sfl-test-reports.s3.ap-south-1.amazonaws.com/";

export const PAYMENTS_URL = process.env.REACT_APP_PAYMENTS_URL || "https://api.sattvamedtech.in/v2/payments";
export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || "https://api-v3.sattvamedtech.in/realtime-tests";

export const LOCAL_AUTH_JWT = "auth_token";
export const LOCAL_EXPIRES_AT = "expires_at";
export const LOCAL_EMAIL_ID = "emailId";
export const LOCAL_NAME = "name";
export const LOCAL_LANG = "lang";
export const LOCAL_TWIN_MODE = "twin_mode";
export const LOCAL_TWIN_OFFSET = "twin_offset";
export const LOCAL_HR_RANGE = "hr_range";
export const LOCAL_PLOT_MHR = "plot_mhr";
export const LOCAL_TEST_GRIDS = "test_grids";
export const LOCAL_FEEDBACK_WINDOW_MIN = "feedback_window_min";
export const LOCAL_DISABLE_ULTRASOUND = "disable_ultrasound";

export const getHrRangeFromStorage = () => {
  try {
    if (typeof localStorage === "undefined") return [60, 200];
    const r = localStorage.getItem(LOCAL_HR_RANGE);
    return r === "30-250" ? [30, 250] : [60, 200];
  } catch {
    return [60, 200];
  }
};

export const GRAPH_FRAGMENTATION_THRESHOLD = 40;
export const CLK_LOCATION = 165;
export const ANNOTATIONS_LOCATION = 175;
export const HR_MIN_RANGE = 80;
export const HR_MAX_RANGE = 180;
export const UA_MIN_RANGE = 0;
export const UA_MAX_RANGE = 100;
export const GRAPH_BREAK_THRESHOLD = 5 * 1000;
export const ERROR_LOCATION = 85;

export const COMPLETED_PARTOGRAMS_INTERVAL = 60 * 1000;
export const ONGOING_PARTOGRAMS_INTERVAL = 10 * 1000;
export const TESTS_INTERVAL = 15 * 1000;

export const EMAIL_REGEX = /^[a-zA-Z0-9_.]+@(?:[a-zA-Z0-9]+\.)+[A-Za-z]+$/;
export const PASSWORD_REGEX = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,20}$/;
export const NAME_REGEX = /^[a-zA-Z ]+$/;
export const CONTACT_REGEX = /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/im;

//Report type
export const DOWNLOAD_REPORT = "download";
export const EMAIL_REPORT = "email";

export const TWIN_MODE_FHR2 = "twin_mode_fhr2";
export const TWIN_MODE_FHR1 = "twin_mode_fhr1";
export const TWIN_MODE_SIMULTANEOUS = "twin_mode_simultaneous";